import React, { useEffect, useState } from "react";
import Modal from 'react-bootstrap/Modal';
import FormRenderer, { ComponentMapper, FormTemplate, componentTypes } from "../../../common/FormRenderer";
import { Button } from "react-bootstrap";
import { getValue } from "../../../../utils/common";
import { GetActionTitle } from "../Master.constants";

function RuleDetails({ action, record: data, onClose }: any) {
    const [ruleDetails, setRuleDetails] = useState<any>({ hideButtons: true });

    const schema = {
        fields: [
            {
                component: componentTypes.PLAIN_TEXT,
                name: 'name',
                label: 'Rule Name',
                content: getValue(ruleDetails, 'name')
            },
            {
                component: componentTypes.PLAIN_TEXT,
                name: 'description',
                label: 'Description',
                content: getValue(ruleDetails, 'description') || '-NA-'
            },
            {
                component: componentTypes.PLAIN_TEXT,
                name: 'type',
                label: 'Type',
                content: getValue(ruleDetails, 'type.value')
            },
            {
                component: componentTypes.PLAIN_TEXT,
                name: 'sectionNo',
                label: 'Section No.',
                content: getValue(ruleDetails, 'section_no')
            },
            {
                component: componentTypes.PLAIN_TEXT,
                name: 'ruleNo',
                label: 'Rule No.',
                content: getValue(ruleDetails, 'rule_no')
            },
            {
                component: componentTypes.PLAIN_TEXT,
                name: 'uniqueIdentifier',
                label: 'Unique Identifier',
                content: getValue(ruleDetails, 'unique_identifier')
            }
        ],
    };

    useEffect(() => {
        if (data) {
            setRuleDetails({
                ...ruleDetails, ...data,
                type: { value: data.rule_type, label: data.rule_type }
            });
        }
    }, [data]);

    return (
        <Modal show={true} backdrop="static" dialogClassName="drawer" animation={false}>
            <Modal.Header closeButton={true} onHide={onClose}>
                <Modal.Title className="bg">{GetActionTitle('Rule', action)}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <FormRenderer FormTemplate={FormTemplate}
                    initialValues={ruleDetails}
                    componentMapper={ComponentMapper}
                    schema={schema}
                />
            </Modal.Body>
            <Modal.Footer className="d-flex justify-content-between">
                {
                    <Button variant="primary" onClick={onClose} className="px-4 ms-auto">{'Close'}</Button>
                }
            </Modal.Footer>
        </Modal>
    )
}

export default RuleDetails;
